var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNovomaticLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 26,
    viewBox: "0 0 120 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.825 21.5986H80.5928V22.2281H118.825V21.5986Z",
    fill: "url(#paint0_linear_360_282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6247 21.5986H0V22.2281H38.6247V21.5986Z",
    fill: "url(#paint1_linear_360_282)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8888 14.4577C22.9704 14.4577 22.0933 14.3442 21.2884 14.1172C20.4732 13.8901 19.7508 13.5186 19.142 13.013C18.5332 12.5073 18.0482 11.8572 17.687 11.0832C17.3362 10.3093 17.1504 9.40119 17.1504 8.36925C17.1504 7.33731 17.3258 6.42919 17.687 5.65524C18.0379 4.88128 18.5332 4.23117 19.142 3.72552C19.7508 3.21987 20.4732 2.82773 21.2884 2.58006C22.1036 2.3324 22.9807 2.19824 23.8991 2.19824C24.8175 2.19824 25.6947 2.32208 26.5099 2.58006C27.3251 2.82773 28.0475 3.21987 28.6563 3.72552C29.2651 4.23117 29.7604 4.88128 30.1113 5.65524C30.4621 6.42919 30.6479 7.33731 30.6479 8.36925C30.6479 9.40119 30.4725 10.3093 30.1113 11.0832C29.7604 11.8572 29.2651 12.5073 28.6563 13.013C28.0475 13.5186 27.3251 13.9004 26.5099 14.1172C25.6844 14.3442 24.8073 14.4577 23.8888 14.4577ZM23.8888 4.48915C23.3832 4.48915 22.8879 4.58203 22.4029 4.75746C21.9179 4.93289 21.4845 5.19087 21.1027 5.52109C20.7312 5.85131 20.4216 6.25377 20.1946 6.72846C19.9675 7.20315 19.854 7.75008 19.854 8.35893C19.854 8.96777 19.9675 9.5147 20.1946 9.98939C20.4216 10.4641 20.7312 10.8665 21.1027 11.1968C21.4845 11.527 21.9179 11.785 22.4029 11.9604C22.8879 12.1358 23.3832 12.2287 23.8888 12.2287C24.3945 12.2287 24.8898 12.1358 25.3748 11.9604C25.8598 11.785 26.2932 11.527 26.675 11.1968C27.0465 10.8665 27.356 10.4641 27.5831 9.98939C27.8101 9.5147 27.9236 8.96777 27.9236 8.35893C27.9236 7.75008 27.8101 7.20315 27.5831 6.72846C27.356 6.25377 27.0465 5.85131 26.675 5.52109C26.2932 5.19087 25.8598 4.93289 25.3748 4.75746C24.8898 4.58203 24.3945 4.48915 23.8888 4.48915Z",
    fill: "url(#paint2_linear_360_282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9757 14.4577C49.0573 14.4577 48.1801 14.3442 47.3752 14.1172C46.56 13.8901 45.8377 13.5186 45.2289 13.013C44.6201 12.5073 44.135 11.8572 43.7739 11.0832C43.423 10.3093 43.2373 9.40119 43.2373 8.36925C43.2373 7.33731 43.423 6.42919 43.7739 5.65524C44.1247 4.88128 44.6201 4.23117 45.2289 3.72552C45.8377 3.21987 46.56 2.82773 47.3752 2.58006C48.1905 2.3324 49.0676 2.19824 49.986 2.19824C50.9044 2.19824 51.7815 2.32208 52.5968 2.58006C53.412 2.83805 54.1343 3.21987 54.7432 3.72552C55.352 4.23117 55.8473 4.88128 56.1982 5.65524C56.5491 6.42919 56.7348 7.33731 56.7348 8.36925C56.7348 9.40119 56.5594 10.3093 56.1982 11.0832C55.8473 11.8572 55.352 12.5073 54.7432 13.013C54.1343 13.5186 53.412 13.9004 52.5968 14.1172C51.7712 14.3442 50.9044 14.4577 49.9757 14.4577ZM49.9757 4.48915C49.4701 4.48915 48.9747 4.58203 48.4897 4.75746C48.0047 4.93289 47.5713 5.19087 47.1895 5.52109C46.818 5.85131 46.5084 6.25377 46.2814 6.72846C46.0544 7.20315 45.9409 7.75008 45.9409 8.35893C45.9409 8.96777 46.0544 9.5147 46.2814 9.98939C46.5084 10.4641 46.818 10.8665 47.1895 11.1968C47.5713 11.527 48.0047 11.785 48.4794 11.9604C48.9644 12.1358 49.4597 12.2287 49.9654 12.2287C50.471 12.2287 50.9663 12.1358 51.4513 11.9604C51.9363 11.785 52.3697 11.527 52.7412 11.1968C53.123 10.8665 53.4223 10.4641 53.6493 9.98939C53.8763 9.5147 53.9899 8.96777 53.9899 8.35893C53.9899 7.75008 53.8763 7.20315 53.6493 6.72846C53.4223 6.25377 53.1127 5.85131 52.7412 5.52109C52.3594 5.19087 51.926 4.93289 51.4513 4.75746C50.987 4.58203 50.4813 4.48915 49.9757 4.48915Z",
    fill: "url(#paint3_linear_360_282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5481 15.789L2.92035 4.67504V15.789H0V0.175781H3.0545L12.3108 10.877V0.175781H15.2311V15.789H12.5481Z",
    fill: "url(#paint4_linear_360_282)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1913 14.3644H35.6424L30.4209 2.33203H33.3206L36.9117 10.7011L40.5028 2.33203H43.4025L38.1913 14.3644Z",
    fill: "url(#paint5_linear_360_282)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3227 14.3644V4.63325H85.1228V2.33203H96.2366V4.63325H92.0367V14.3644H89.3227Z",
    fill: "url(#paint6_linear_360_282)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.973 2.33203H98.2385V14.3541H100.973V2.33203Z",
    fill: "url(#paint7_linear_360_282)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7403 14.3649L82.4916 11.4445H77.2391L75.9906 14.3649H73.2766L78.591 2.34277H81.1192L86.4336 14.3649H83.7403ZM81.5113 9.13294L79.8603 5.26317L78.2091 9.13294H81.5113Z",
    fill: "url(#paint8_linear_360_282)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.86 15.8816C110.704 15.8816 109.58 15.7164 108.517 15.4069C107.454 15.087 106.494 14.5916 105.689 13.9415C104.874 13.2811 104.224 12.4452 103.739 11.4649C103.264 10.4845 103.017 9.31842 103.017 7.98721C103.017 6.68697 103.254 5.52088 103.739 4.53022C104.214 3.53955 104.874 2.69336 105.689 2.0226C106.504 1.35184 107.454 0.846189 108.517 0.505648C109.58 0.175428 110.704 0 111.86 0C114.203 0 116.39 0.784276 117.814 1.37248C117.979 1.44472 118.929 1.86781 118.929 1.86781L117.443 4.33414L117.226 4.21032C115.771 3.33317 114.12 2.7656 112.582 2.60049C112.324 2.56953 112.077 2.54889 111.85 2.54889H111.736H111.654C110.942 2.56953 110.261 2.68304 109.621 2.89975C108.909 3.1371 108.29 3.48796 107.763 3.94201C107.237 4.39606 106.814 4.96363 106.504 5.62407C106.195 6.28451 106.03 7.04815 106.03 7.89434C106.03 8.74053 106.185 9.51449 106.494 10.1646C106.804 10.825 107.227 11.3926 107.753 11.8467C108.279 12.3007 108.898 12.6516 109.611 12.8889C110.323 13.1263 111.066 13.2501 111.839 13.2501C114.337 13.2501 116.452 12.0943 117.783 11.1243L118.01 10.9592L119.331 13.2295L119.135 13.3636C117.474 14.4265 114.956 15.7164 112.335 15.8712C112.18 15.8712 112.025 15.8816 111.86 15.8816Z",
    fill: "url(#paint9_linear_360_282)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1386 2.33203L65.2174 9.48337L61.2961 2.33203H58.644V14.3644H61.0381V6.8932L65.2174 14.3954L69.3966 6.8932V14.3644H71.801V2.33203H69.1386Z",
    fill: "url(#paint10_linear_360_282)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9205 20.1745C45.6522 19.9475 45.3426 19.7721 45.0021 19.6689C44.6615 19.5553 44.321 19.5038 43.9598 19.5038C43.8257 19.5038 43.6709 19.5141 43.5058 19.5347C43.3406 19.5554 43.1859 19.5966 43.0311 19.6585C42.8866 19.7205 42.7525 19.803 42.6493 19.9165C42.5461 20.03 42.4945 20.1642 42.4945 20.3396C42.4945 20.5047 42.5358 20.6492 42.6286 20.7524C42.7215 20.8556 42.835 20.9381 42.9795 21.0001C43.124 21.062 43.2994 21.1136 43.4955 21.1549C43.6916 21.1961 43.8876 21.2271 44.0836 21.2684C44.4345 21.3303 44.7648 21.4025 45.095 21.4851C45.4252 21.5676 45.7141 21.6811 45.9618 21.8256C46.2094 21.9701 46.4159 22.1558 46.5706 22.3932C46.7254 22.6202 46.7976 22.9195 46.7976 23.2807C46.7976 23.6728 46.7151 24.003 46.5397 24.2507C46.3642 24.4983 46.1476 24.7047 45.8689 24.8492C45.6006 24.9937 45.2911 25.0969 44.9712 25.1588C44.6409 25.2207 44.321 25.2413 44.0115 25.2413C43.7432 25.2413 43.4645 25.2207 43.1859 25.1794C42.9072 25.1381 42.6389 25.0659 42.3706 24.973C42.1127 24.8802 41.865 24.7563 41.6379 24.5912C41.4109 24.4364 41.2148 24.2404 41.0601 24.003L41.9166 23.2084C42.0404 23.3942 42.1745 23.549 42.3397 23.6728C42.5048 23.7966 42.6699 23.8998 42.8556 23.972C43.0414 24.0443 43.2374 24.1062 43.4438 24.1372C43.6502 24.1784 43.8567 24.1888 44.063 24.1888C44.2178 24.1888 44.3829 24.1784 44.5687 24.1578C44.7544 24.1372 44.9299 24.0959 45.0846 24.0443C45.2394 23.9824 45.3736 23.8895 45.4768 23.776C45.58 23.6625 45.6315 23.4974 45.6315 23.3116C45.6315 23.1155 45.5696 22.9608 45.4458 22.8472C45.322 22.7337 45.1569 22.6408 44.9505 22.5686C44.7441 22.4964 44.5171 22.4345 44.2591 22.3829C44.0011 22.3313 43.7328 22.2797 43.4645 22.2281C43.1962 22.1765 42.9279 22.1146 42.6699 22.032C42.4119 21.9494 42.1849 21.8463 41.9785 21.7121C41.7721 21.578 41.607 21.4128 41.4832 21.2064C41.3594 21.0001 41.2974 20.7421 41.2974 20.4325C41.2974 20.0713 41.38 19.7617 41.5451 19.5038C41.7102 19.2561 41.9166 19.0497 42.1746 18.8949C42.4326 18.7401 42.7112 18.6266 43.0311 18.5544C43.3407 18.4821 43.6503 18.4512 43.9495 18.4512C44.4036 18.4512 44.8576 18.5028 45.322 18.606C45.776 18.7092 46.1991 18.9052 46.5603 19.1942L45.9205 20.1745Z",
    fill: "url(#paint11_linear_360_282)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8503 25.0864V18.5542H53.1855V19.6274H49.0371V21.2579H52.7314V22.1866H49.0371V23.9822H53.2887V25.0864H47.8503Z",
    fill: "url(#paint12_linear_360_282)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5316 25.0864L57.736 22.8058H55.538V25.0864H54.3513V18.5542H57.8908C58.3448 18.5542 58.7164 18.6058 59.0156 18.7193C59.3149 18.8328 59.5625 18.9773 59.7483 19.1734C59.934 19.3694 60.0579 19.5861 60.1301 19.8441C60.2023 20.1021 60.2436 20.3807 60.2436 20.68C60.2436 21.1341 60.1198 21.5262 59.8721 21.8667C59.6245 22.2073 59.2736 22.424 58.8195 22.5272L60.9453 25.0864H59.5316ZM55.5484 19.6481V21.8358H57.8289C57.994 21.8358 58.1591 21.8151 58.3139 21.7739C58.4687 21.7326 58.6029 21.6707 58.7164 21.5778C58.8299 21.4849 58.933 21.3714 58.995 21.2372C59.0672 21.0928 59.0982 20.9277 59.0982 20.7316C59.0982 20.5355 59.0672 20.3704 59.0053 20.2363C58.9434 20.1021 58.8505 19.9886 58.737 19.906C58.6235 19.8235 58.4893 19.7616 58.3242 19.7203C58.1695 19.679 57.994 19.6584 57.8185 19.6584H55.5484V19.6481Z",
    fill: "url(#paint13_linear_360_282)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7192 25.0864V18.5542H64.7737C65.558 18.5542 66.1771 18.6987 66.6002 18.9979C67.0336 19.2972 67.2503 19.7306 67.2503 20.3188C67.2503 20.6387 67.1781 20.907 67.0336 21.134C66.8892 21.3611 66.6725 21.5056 66.3732 21.5881C66.5486 21.6191 66.7137 21.6707 66.8685 21.7429C67.0233 21.8151 67.1678 21.9183 67.2813 22.0525C67.4051 22.1763 67.498 22.3311 67.5702 22.5065C67.6424 22.682 67.6734 22.8883 67.6734 23.1257C67.6734 23.7552 67.467 24.2299 67.0439 24.5704C66.6311 24.911 66.0327 25.0761 65.2587 25.0761H61.7192V25.0864ZM62.906 19.6481V21.3198H65.0111C65.2278 21.3198 65.4135 21.2992 65.5477 21.2476C65.6921 21.196 65.7953 21.1341 65.8779 21.0515C65.9605 20.9689 66.012 20.8761 66.043 20.7729C66.0739 20.6697 66.0842 20.5562 66.0842 20.453C66.0842 20.2156 66.0017 20.0196 65.8366 19.8751C65.6715 19.7306 65.3825 19.6481 64.9904 19.6481H62.906ZM62.906 22.135V23.9822H65.2587C65.6818 23.9822 65.9914 23.8997 66.2081 23.7449C66.4144 23.5798 66.528 23.363 66.528 23.0638C66.528 22.8987 66.497 22.7542 66.4351 22.6304C66.3732 22.5169 66.2803 22.4137 66.1668 22.3414C66.0533 22.2692 65.9191 22.2176 65.7747 22.1866C65.6199 22.1557 65.4651 22.135 65.2897 22.135H62.906Z",
    fill: "url(#paint14_linear_360_282)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7053 25.0864V18.5542H69.892V25.0864H68.7053Z",
    fill: "url(#paint15_linear_360_282)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2496 25.0864L76.3931 23.3734H72.8743L72.0178 25.0864H70.6763L74.061 18.5542H75.1961L78.6324 25.0864H77.2496ZM74.6492 19.8544L73.3283 22.4446H75.9494L74.6492 19.8544Z",
    fill: "url(#paint16_linear_360_282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_282",
    x1: 80.5928,
    y1: 21.9134,
    x2: 118.825,
    y2: 21.9134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_282",
    x1: 0,
    y1: 21.9134,
    x2: 38.6247,
    y2: 21.9134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_360_282",
    x1: 17.1504,
    y1: 8.32797,
    x2: 30.6479,
    y2: 8.32797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_360_282",
    x1: 43.2373,
    y1: 8.32797,
    x2: 56.7348,
    y2: 8.32797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_360_282",
    x1: 0,
    y1: 7.98241,
    x2: 15.2311,
    y2: 7.98241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_360_282",
    x1: 30.4209,
    y1: 8.34824,
    x2: 43.4025,
    y2: 8.34824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_360_282",
    x1: 85.1228,
    y1: 8.34824,
    x2: 96.2366,
    y2: 8.34824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_360_282",
    x1: 98.2385,
    y1: 8.34308,
    x2: 100.973,
    y2: 8.34308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_360_282",
    x1: 73.2766,
    y1: 8.35382,
    x2: 86.4336,
    y2: 8.35382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_360_282",
    x1: 103.017,
    y1: 7.94078,
    x2: 119.331,
    y2: 7.94078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_360_282",
    x1: 58.644,
    y1: 8.36372,
    x2: 71.801,
    y2: 8.36372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_360_282",
    x1: 41.0601,
    y1: 21.8463,
    x2: 46.7976,
    y2: 21.8463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_360_282",
    x1: 47.8503,
    y1: 21.8203,
    x2: 53.2887,
    y2: 21.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_360_282",
    x1: 54.3513,
    y1: 21.8203,
    x2: 60.9453,
    y2: 21.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_360_282",
    x1: 61.7192,
    y1: 21.8203,
    x2: 67.6734,
    y2: 21.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_360_282",
    x1: 68.7053,
    y1: 21.8203,
    x2: 69.892,
    y2: 21.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_360_282",
    x1: 70.6763,
    y1: 21.8203,
    x2: 78.6324,
    y2: 21.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C4C2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#E3E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#F7F7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#F9F9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#E9E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D0D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A6A6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACACA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovomaticLogo1);
export default __webpack_public_path__ + "static/media/Novomatic-logo-1.88f161bdaca023a2c3d5504ff7669581.svg";
export { ForwardRef as ReactComponent };